<template>
  <a-modal
    title="Dodaj dostępność"
    width="40vw"
    wrapClassName="modal-wrapper"
    v-model="visible"
    @ok="onSubmit"
    @cancel="closeModal"
    :confirm-loading="loading"
    okText="Zapisz"
    cancelText="Anuluj"
  >
    <inner-form
      v-model="form"
      :errors="errors"
      :lecturers="lecturers"
      @submit="onSubmit"
      :selectedDate.sync="selectedDate"
    />
  </a-modal>
</template>
<script>
import InnerForm from './InnerForm'
import { Availability } from '@/api'
import moment from 'moment'
import { Lecturer } from '@/api'

export default {
  data() {
    return {
      visible: false,
      loading: false,
      form: {
        timespan: {}
      },
      selectedDate: null,
      errors: {},
      lecturers: []
    }
  },
  components: {
    InnerForm
  },
  methods: {
    getDefaultTimespan() {
      return this.selectedDate
        ? {
            lower: this.selectedDate.clone(),
            upper: this.selectedDate.clone().add(1, 'h')
          }
        : { lower: undefined, upper: undefined }
    },
    openModal(selectedDate, lecturerId) {
      selectedDate = selectedDate ? moment(selectedDate) : moment()
      this.selectedDate = this.stripMinuteAndSeconds(selectedDate)
      if (!lecturerId) {
        this.fetchLecturers()
      }
      this.form = {
        timespan: this.getDefaultTimespan(),
        lecturer: lecturerId
      }
      this.visible = true
    },
    fetchLecturers() {
      const params = { is_active: true }
      Lecturer.all(params).then(res => {
        this.lecturers = res.data.results.map(lecturer => ({
          label: lecturer.full_name,
          value: lecturer.id
        }))
        if (this.lecturers.length === 1) {
          this.form.lecturer = this.lecturers[0].value
        }
      })
    },
    onSubmit() {
      this.loading = true
      Availability.save(this.form)
        .then(() => {
          this.$notification.success({ message: 'Dostępność dodana' })
          this.closeModal()
          this.$emit('submit')
        })
        .catch(err => {
          this.errors = err.response.data
        })
        .finally(() => {
          this.loading = false
        })
    },
    closeModal() {
      this.form = {
        timespan: {}
      }
      this.errors = {}
      this.selectedDate = null
      this.visible = false
    }
  }
}
</script>
